webpackJsonp([1],{

/***/ "2LUs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3LmT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iconButton",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('img', {
    staticClass: "iconButton__image",
    attrs: {
      "src": _vm.iconSrc || _vm.defaultSrc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iconButton__aura",
    class: {
      expand: _vm.clicked
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4GPP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "go",
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.choupi) ? _c('div', {
    staticClass: "far fa-heart go__heart",
    class: {
      expand: _vm.clicked
    }
  }) : _c('div', {
    staticClass: "go__circle",
    class: {
      expand: _vm.clicked
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "go__text",
    domProps: {
      "innerHTML": _vm._s(_vm.result)
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6k9n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6u58":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Go',
  props: ['answer', 'choupi'],
  data: function data() {
    return {
      text: this.choupi ? '' : 'Go !',
      clicked: false
    };
  },

  methods: {
    handleClick: function handleClick() {
      this.clicked = !this.clicked;
    }
  },
  computed: {
    result: function result() {
      if (this.clicked) {
        return this.answer;
      } else {
        return this.text;
      }
    }
  }
});

/***/ }),

/***/ "7BLg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drawer",
    class: {
      'drawer--open': _vm.drawer.open
    }
  }, [_c('div', {
    staticClass: "drawer__title"
  }, [_vm._v("\n    Change question\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "drawer__items"
  }, _vm._l((_vm.questions), function(question) {
    return _c('li', {
      staticClass: "drawer__item",
      on: {
        "click": function($event) {
          _vm.handlePick(question)
        }
      }
    }, [_vm._v("\n      " + _vm._s(question.name) + "\n    ")])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7xES":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "99op":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Go_vue__ = __webpack_require__("6u58");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d3d9314_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Go_vue__ = __webpack_require__("4GPP");
function injectStyle (ssrContext) {
  __webpack_require__("yMhB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d3d9314"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Go_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d3d9314_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Go_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CWKO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    nativeOn: {
      "click": function($event) {
        _vm.focus($event)
      }
    }
  }), _vm._v(" "), _c('Drawer')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HI7M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello",
    style: (_vm.currentQuestion.theme)
  }, [_c('Go', {
    staticClass: "hello__button",
    attrs: {
      "answer": _vm.answer,
      "choupi": _vm.currentQuestion.choupi
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClick($event)
      }
    }
  }), _vm._v(" "), (this.currentQuestion.count) ? _c('Counter', {
    staticClass: "hello__counter"
  }) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KTVV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_vm._v("\n  " + _vm._s(_vm.name) + "\n")])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427a9fc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("CWKO");
function injectStyle (ssrContext) {
  __webpack_require__("pE3G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427a9fc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mwt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'napolitano',
  data: function data() {
    return {
      name: 'Al Pacino'
    };
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("olkN");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.devtools = true;


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/sw.js').then(function (registration) {
      console.log('SW registered: ', registration);
    }).catch(function (registrationError) {
      console.log('SW registration failed: ', registrationError);
    });
  });
}

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] },
  store: new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */])
});

/***/ }),

/***/ "U25B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vcg/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IconButton',
  props: ['iconSrc', 'mutation'],
  data: function data() {
    return {
      defaultSrc: null,
      clicked: false
    };
  },

  methods: {
    handleClick: function handleClick() {
      var _this = this;

      if (this.clicked) {
        this.clicked = false;
      }
      this.clicked = true;
      setTimeout(function () {
        _this.clicked = false;
      }, 500);
      this.$store.commit(this.mutation);
    }
  }
});

/***/ }),

/***/ "W5n8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Counter_vue__ = __webpack_require__("paBX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d868100_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Counter_vue__ = __webpack_require__("naEv");
function injectStyle (ssrContext) {
  __webpack_require__("7xES")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Counter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d868100_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Counter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Hello__ = __webpack_require__("j80A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Napolitano__ = __webpack_require__("qlDA");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Hello__["a" /* default */]
  }, {
    path: '/Napolitano',
    name: 'Napolitano',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Napolitano__["a" /* default */]
  }],
  mode: 'history'
}));

/***/ }),

/***/ "fm2A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drawer_vue__ = __webpack_require__("rcYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f9589c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Drawer_vue__ = __webpack_require__("7BLg");
function injectStyle (ssrContext) {
  __webpack_require__("6k9n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f9589c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drawer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f9589c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Drawer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iTor":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconButton_vue__ = __webpack_require__("Vcg/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09218c92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_IconButton_vue__ = __webpack_require__("3LmT");
function injectStyle (ssrContext) {
  __webpack_require__("U25B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09218c92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09218c92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_IconButton_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j80A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__("k8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da055350_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("HI7M");
function injectStyle (ssrContext) {
  __webpack_require__("2LUs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-da055350"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da055350_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k8XX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_atoms_Go__ = __webpack_require__("99op");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_Counter__ = __webpack_require__("W5n8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'No more bets !',
      answer: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    setTheme: function setTheme() {
      return this.currentQuestion.theme;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['count', 'questionColor']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapGetters */])(['currentQuestion'])),
  components: {
    Go: __WEBPACK_IMPORTED_MODULE_1__components_atoms_Go__["a" /* default */], Counter: __WEBPACK_IMPORTED_MODULE_2__components_atoms_Counter__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick() {
      var possibleAnswers = this.currentQuestion.answers;
      this.answer = possibleAnswers[Math.floor(Math.random() * possibleAnswers.length)];
    }
  }
});

/***/ }),

/***/ "naEv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "counter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.count),
      expression: "count"
    }],
    staticClass: "counter__input",
    attrs: {
      "type": "text",
      "readonly": "",
      "name": "optionsNb",
      "value": "",
      "placeholder": "?"
    },
    domProps: {
      "value": (_vm.count)
    },
    on: {
      "click": _vm.reset,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.count = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "counter__buttons"
  }, [_c('div', {
    staticClass: "counter__button counter__button--up",
    on: {
      "mouseover": _vm.mouseOver,
      "mouseleave": _vm.mouseLeave,
      "mousedown": function($event) {
        _vm.handleHold($event, function () { return _vm.count++; })
      },
      "mouseup": _vm.handleHold,
      "touchstart": function($event) {
        _vm.handleHold($event, function () { return _vm.count++; })
      },
      "touchend": _vm.handleHold
    }
  }, [_vm._v("▲")]), _vm._v(" "), _c('div', {
    staticClass: "counter__button counter__button--down",
    on: {
      "mouseover": _vm.mouseOver,
      "mouseleave": _vm.mouseLeave,
      "mousedown": function($event) {
        _vm.handleHold($event, _vm.decrement)
      },
      "mouseup": _vm.handleHold,
      "touchstart": function($event) {
        _vm.handleHold($event, _vm.decrement)
      },
      "touchend": _vm.handleHold
    }
  }, [_vm._v("▼")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o5Mc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    questionColor: 'blue',
    questions: [{
      name: 'Yes / No',
      color: 'blue',
      theme: {
        backgroundColor: '#5dbfdd',
        color: '#8adaf3'
      },
      answers: ['Yes !', 'No !'],
      selected: false
    }, {
      name: 'Left / Right',
      color: 'red',
      theme: {
        backgroundColor: '#f15b5b',
        color: '#e89696'
      },
      answers: ['&#8592;', '&#8594;'],
      selected: false
    }, {
      name: 'Heads or Tails',
      color: 'green',
      theme: {
        backgroundColor: '#38c161',
        color: '#77dd77'
      },
      answers: ['Heads !', 'Tails !'],
      selected: false
    }, {
      name: 'Multiple options',
      color: 'purple',
      theme: {
        backgroundColor: '#804d9a',
        color: '#b470ca'
      },
      answers: [],
      selected: false,
      count: true
    }, {
      name: 'Choupinette',
      choupi: true,
      color: 'pink',
      theme: {
        background: 'linear-gradient(#8A2387, #E94057, #F27121)',
        color: 'midnightBlue'
      },
      answers: ['我愛你', 'luv u bae', 'Manue > all', 'la meilleure', 'la plus belle', 'Je t\'aime !', '#1 sur la peau douce', 'jolie même avec de la paille grasse sur la tête', 'trop choupinette', 'legendary blocker', 'Hall of Fame roller derby', 'la plus drôle', 'le monde entier m\'envie', 'copine de l\'année', '❤', 'même tes sœurs sont sympas', 'si je devais partir sur un île déserte je prendrais toi avant une tarte au citron', 'gentille et badass à la fois', 'la plus Manuefique', 'Je suis Emmarveillé devant toi', 'tu sens très bon', 'ma meilleure élève', 'lune de mes nuits', 'phare de mes tempêtes', 'Amy de mon Jake', 'Je pourrais manger des artichauts pour toi', 'meilleure partenaire de danse', 'championne du monde de beaux yeux'],
      selected: true
    }],
    drawer: {
      open: false
    }
  },
  getters: {
    currentQuestion: function currentQuestion(state) {
      return state.questions.find(function (question) {
        return question.selected;
      });
    }
  },
  mutations: {
    colorize: function colorize(state, payload) {
      state.questionColor = payload.color;
    },
    toggleDrawer: function toggleDrawer(state) {
      state.drawer.open = !state.drawer.open;
    },
    closeDrawer: function closeDrawer(state) {
      state.drawer.open = false;
    },
    changeQuestion: function changeQuestion(state, payload) {
      state.questions.forEach(function (question) {
        question === payload.question ? question.selected = true : question.selected = false;
      });
    },
    initAnswers: function initAnswers(state, payload) {
      var currentQuestion = state.questions.find(function (question) {
        return payload.question === question;
      });
      currentQuestion.answers = [];
      var i = 1;
      while (currentQuestion.answers.length < payload.answersNb) {
        currentQuestion.answers.push(i + ' !');
        i++;
      }
    }
  }
});

/***/ }),

/***/ "pE3G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "paBX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Counter',
  data: function data() {
    return {
      count: 0,
      intervalDown: {}
    };
  },

  methods: {
    mouseOver: function mouseOver(e) {
      e.target.style.color = this.currentQuestion.theme.backgroundColor;
      e.target.style.backgroundColor = this.currentQuestion.theme.color;
    },
    mouseLeave: function mouseLeave(e) {
      e.target.style.color = '';
      e.target.style.backgroundColor = '';
    },
    decrement: function decrement() {
      if (this.count > 0) {
        this.count--;
      }
    },
    handleHold: function handleHold(e, f) {
      if (e.type === 'mousedown' || e.type === 'touchstart') {
        f();
        this.intervalDown = setInterval(function () {
          f();
        }, 200);
      } else if (e.type === 'mouseup' || e.type === 'touchend') {
        clearInterval(this.intervalDown);
        this.setAnswers();
      }
    },
    reset: function reset() {
      this.count = 0;
    },
    setAnswers: function setAnswers() {
      var payload = {
        question: this.currentQuestion,
        answersNb: this.count
      };
      this.$store.commit('initAnswers', payload);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapGetters */])(['currentQuestion']))
});

/***/ }),

/***/ "qlDA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Napolitano_vue__ = __webpack_require__("Mwt7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72a0f5dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Napolitano_vue__ = __webpack_require__("KTVV");
function injectStyle (ssrContext) {
  __webpack_require__("o5Mc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72a0f5dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Napolitano_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72a0f5dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Napolitano_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rcYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Drawer',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['questions', 'drawer'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    handlePick: function handlePick(question) {
      this.$store.commit('changeQuestion', { question: question });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['']))
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_atoms_IconButton__ = __webpack_require__("iTor");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_organisms_Drawer__ = __webpack_require__("fm2A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_burger_svg__ = __webpack_require__("ybrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_burger_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_burger_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      iconImage: __WEBPACK_IMPORTED_MODULE_3__assets_burger_svg___default.a
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    focus: function focus() {
      if (this.drawer.open) {
        this.closeDrawer();
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapMutations */])(['closeDrawer'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapState */])(['drawer'])),
  components: {
    IconButton: __WEBPACK_IMPORTED_MODULE_1__components_atoms_IconButton__["a" /* default */], Drawer: __WEBPACK_IMPORTED_MODULE_2__components_organisms_Drawer__["a" /* default */]
  }
});

/***/ }),

/***/ "yMhB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ybrw":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGhlaWdodD0iMzJweCIgaWQ9IkxheWVyXzEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDMyIDMyOyIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgMzIgMzIiIHdpZHRoPSIzMnB4IiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48cGF0aCBmaWxsPSIjZGRkIiBkPSJNNCwxMGgyNGMxLjEwNCwwLDItMC44OTYsMi0ycy0wLjg5Ni0yLTItMkg0QzIuODk2LDYsMiw2Ljg5NiwyLDhTMi44OTYsMTAsNCwxMHogTTI4LDE0SDRjLTEuMTA0LDAtMiwwLjg5Ni0yLDIgIHMwLjg5NiwyLDIsMmgyNGMxLjEwNCwwLDItMC44OTYsMi0yUzI5LjEwNCwxNCwyOCwxNHogTTI4LDIySDRjLTEuMTA0LDAtMiwwLjg5Ni0yLDJzMC44OTYsMiwyLDJoMjRjMS4xMDQsMCwyLTAuODk2LDItMiAgUzI5LjEwNCwyMiwyOCwyMnoiLz48L3N2Zz4K"

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.42bfe491c77da4f3a806.js